module.exports = __webpack_public_path__ + "fonts/AudiType-Normal_4.03.b718e591.woff2";